import { api } from './api'
import { Message, ChatFormData } from '../types/chat'

export const chatService = {
  /**
   * Get all messages (team messages and direct messages for current user)
   */
  getAll: async (): Promise<Message[]> => {
    const response = await api.get<Message[]>('/chat/messages')
    return response.data
  },

  /**
   * Get team messages only
   */
  getTeamMessages: async (): Promise<Message[]> => {
    const response = await api.get<Message[]>('/chat/messages/team')
    return response.data
  },

  /**
   * Get direct messages between current user and another user
   */
  getDirectMessages: async (userId: string): Promise<Message[]> => {
    const response = await api.get<Message[]>(`/chat/messages/direct/${userId}`)
    return response.data
  },

  /**
   * Send a message
   */
  sendMessage: async (data: ChatFormData): Promise<Message> => {
    const response = await api.post<Message>('/chat/messages', data)
    return response.data
  },

  /**
   * Mark messages as read
   */
  markAsRead: async (messageIds: string[]): Promise<void> => {
    await api.post('/chat/messages/read', { messageIds })
  },

  /**
   * Get unread message count for current user
   */
  getUnreadCount: async (): Promise<number> => {
    const response = await api.get<{ count: number }>('/chat/messages/unread-count')
    return response.data.count
  },

  /**
   * Update/edit a message
   */
  updateMessage: async (messageId: string, content: string): Promise<Message> => {
    const response = await api.put<Message>(`/chat/messages/${messageId}`, { content })
    return response.data
  },

  /**
   * Delete a message
   */
  deleteMessage: async (messageId: string): Promise<Message> => {
    const response = await api.delete<Message>(`/chat/messages/${messageId}`)
    return response?.data || {} as Message
  },

  /**
   * Add a reaction to a message
   */
  addReaction: async (messageId: string, emoji: string): Promise<Message> => {
    const response = await api.post<Message>(`/chat/messages/${messageId}/reactions`, { emoji })
    return response.data
  },

  /**
   * Remove a reaction from a message
   */
  removeReaction: async ({ messageId, emoji }: { messageId: string; emoji: string }): Promise<Message> => {
    const response = await api.delete<Message>(`/chat/messages/${messageId}/reactions?emoji=${encodeURIComponent(emoji)}`)
    return response?.data || {} as Message
  },
}































